import {
  Api,
  ContentType,
  HttpClient,
} from '@asset-metrix/portal-api-client-js';
import { v4 as uuid } from 'uuid';

import Session from './Session';

export type PortalApiClient = Api<unknown>;

export const getTracingHeaders = (session?: Session) => ({
  'X-Request-Id': uuid(),
  'X-Session-Id': session?.getDecodedAuthToken()?.jti ?? 'no-session-id',
});

export const getRequestHeaders = (session: Session) => ({
  ...(session.getAuthToken()
    ? { authorization: `Bearer ${session.getAuthToken()}` }
    : {}),
  ...getTracingHeaders(session),
});

export const createPortalApiClient = ({
  apiId,
  baseUrl,
  session,
}: {
  apiId: string;
  baseUrl: string;
  session: Session;
}): PortalApiClient => {
  const httpClient = new HttpClient({
    baseApiParams: {
      headers: {
        'Content-Type': ContentType.Json,
        'x-api-id': apiId,
      },
      type: ContentType.Json,
    },
    baseUrl,
    securityWorker: () => ({
      headers: getRequestHeaders(session),
    }),
  });

  console.debug('Portal-API client initialized with baseUrl %s', baseUrl);

  return new Api(httpClient);
};
